/**
 * Loads the runtime configuration from /config.json.
 * This file is generated by CI/CD and deployed to S3 alongside the static assets.
 * It provides Cognito configuration for aws-amplify.
 */
import type { AppConfig } from '@dermalink/shared';

let _config: AppConfig | null = null;

export async function loadConfig(): Promise<AppConfig> {
  if (_config) return _config;

  const res = await fetch('/config.json');
  if (!res.ok) {
    throw new Error(`Failed to load /config.json: ${res.status} ${res.statusText}`);
  }

  _config = (await res.json()) as AppConfig;
  return _config;
}

export function getConfig(): AppConfig {
  if (!_config) {
    throw new Error('Config not loaded. Call loadConfig() first.');
  }
  return _config;
}
